import { render, staticRenderFns } from "./message-pushed-add.vue?vue&type=template&id=38b35c7e&scoped=true&"
import script from "./message-pushed-add.vue?vue&type=script&lang=js&"
export * from "./message-pushed-add.vue?vue&type=script&lang=js&"
import style0 from "./message-pushed-add.vue?vue&type=style&index=0&id=38b35c7e&lang=scss&scoped=true&"
import style1 from "./message-pushed-add.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b35c7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38b35c7e')) {
      api.createRecord('38b35c7e', component.options)
    } else {
      api.reload('38b35c7e', component.options)
    }
    module.hot.accept("./message-pushed-add.vue?vue&type=template&id=38b35c7e&scoped=true&", function () {
      api.rerender('38b35c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/marketing-manage/message-pushed/message-pushed-add.vue"
export default component.exports